export const templatesColumns = [
  { id: 'name', label: 'Name', sortable: true },
  { id: 'type', label: 'Type', sortable: false },
  { id: 'actions', label: 'Actions', sortable: false },
];
